import { render, staticRenderFns } from "./FichaEstudiante.vue?vue&type=template&id=1e431566&"
import script from "./FichaEstudiante.vue?vue&type=script&lang=js&"
export * from "./FichaEstudiante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports